import { useEffect } from 'react';

import { THEME } from 'src/enums/theme';
import { useThemeConfig } from 'src/hooks/use-theme-config';

export const ThemeBridge = () => {
  const { themeConfig } = useThemeConfig();

  useEffect(() => {
    const html = document.documentElement;

    html.classList.remove('rebrandOn');
    if (themeConfig.value === THEME.REBRAND_LIGHT || themeConfig.value === THEME.REBRAND_DARK) {
      html.classList.add('rebrandOn');
    }
  }, [themeConfig.value]);

  return null;
};
